export const ProcessType = Object.freeze({
    EXTRACTION: 'extraction',
    FILE_UPLOAD: 'file upload',
    REPO_CREATION: 'repo creation',
    SupportInfoExtraction: 'Auto Extraction',
    KNOWLEDGE_GRAPH_CREATION: 'Knowledge Graph Creation',
    QUESTION_GENERATION: 'Question Generation',
    ASYNC_AGENT_EXECUTION: 'agent_execution',
    ALERT: 'alert',
});
